import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import { Navbar } from "../../../Components/Navbar/Navbar";
import { Footer } from "../../../Components/Footer/footer";
import "./style.css";

interface Legislation {
  id: string;
  title: string;
  description: string;
  pdf_url: string;
  category?: string;
}

interface JusticeConfig {
  header_image?: string;
  legislations?: Legislation[];
}

export function LegislatiePage() {
  const [headerImage, setHeaderImage] = useState<string | null>(null);
  const [grouped, setGrouped] = useState<Record<string, Legislation[]>>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const snap = await getDoc(doc(db, "site_content", "justice_page"));
        if (snap.exists()) {
          const data = snap.data() as JusticeConfig;

          if (data.header_image) setHeaderImage(data.header_image);

          const items = (data.legislations || [])
            .filter(l => l.pdf_url && l.title)
            .map((l, idx) => ({
              id: l.id || `law-${idx}`,
              title: l.title,
              description: l.description || "",
              pdf_url: l.pdf_url,
              category: l.category?.trim() || "Alte acte normative",
            }));

          const groupedBy: Record<string, Legislation[]> = {};
          for (const law of items) {
            const cat = law.category || "Alte acte normative";
            if (!groupedBy[cat]) groupedBy[cat] = [];
            groupedBy[cat].push(law);
          }

          setGrouped(groupedBy);
        } else {
          setGrouped({});
        }
      } catch (err) {
        console.error("Error loading justice_page:", err);
        setGrouped({});
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const categories = Object.keys(grouped).sort(
    (a, b) => a.localeCompare(b, "ro", { sensitivity: "base" })
  );

  return (
    <div className="page-container">
      <Navbar />
      <div className="justice-page">
       {/* --- FULL-WIDTH HERO BANNER --- */}
<div className="justice-banner">
  {headerImage && (
    <img
      src={headerImage}
      alt="Legislație Sanitas"
      className="justice-banner-image"
    />
  )}
  <div className="justice-banner-overlay">
    <h1>Legislație</h1>
    <p>
      Documente oficiale, contracte colective, norme și reglementări
      esențiale pentru drepturile lucrătorilor din sănătate și asistență socială.
    </p>
  </div>
</div>

        {loading ? (
          <div className="justice-loading">Se încarcă documentele...</div>
        ) : categories.length === 0 ? (
          <div className="justice-empty">
            Momentan nu există documente publicate în această secțiune.
          </div>
        ) : (
          <div className="justice-content">
            {categories.map(category => {
              const list = grouped[category] || [];
              return (
                <section key={category} className="leg-category">
                  <div className="leg-category-header">
                    <h2>{category}</h2>
                    <span className="leg-count">
                      {list.length} document
                      {list.length > 1 ? "e" : ""}
                    </span>
                  </div>

                  <div className="leg-grid">
                    {list.map(item => (
                      <article key={item.id} className="leg-card">
                        <h3 className="leg-title">{item.title}</h3>
                        {item.description && (
                          <p className="leg-desc">{item.description}</p>
                        )}
                        <a
                          href={item.pdf_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="leg-link"
                        >
                          Descarcă PDF
                        </a>
                      </article>
                    ))}
                  </div>
                </section>
              );
            })}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}